// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__bUlAL","content":"LayoutSettings_content__1D2mK"};